import React, { useEffect, useState } from "react";
import Missions from "../components/Missions";
import { useParams } from "react-router-dom";
import Go from "./Go";
import PaymentFormModal from "../components/common/modal/PaymentFormModal";
import { useSelector } from "react-redux";
import { getMissions } from "../store/missions";
import MissionLoader from "../components/hoc/missionLoader";
import PlayLoader from "../components/hoc/playLoader";
import { validator } from "../utils/validator";
import { getCurrentGroup } from "../store/groups";
import { useI18n } from "../i18n/LanguageContext";

function ListGo(props) {
  const { t } = useI18n();
  const params = useParams();
  const group = useSelector(getCurrentGroup());

  const [modal, setModal] = useState(false);

  const missions = useSelector(getMissions());
  const [missionId, setMissionId] = useState(null);

  const [errors, setErrors] = useState({});

  const [data, setData] = useState();

  useEffect(() => {
    if (group !== undefined) {
      setData({ town: group?.town, missionId: group?.missionId });
    }
  }, [group]);

  const paymentForm = (id) => {
    if (modal === false) {
      setModal(true);
      setMissionId(id);
    } else {
      setMissionId(null);
      setModal(false);
    }
  };

  const validatorConfig = {
    town: {
      isRequireTown: {
        message: t("register.err.town"),
      },
      isTownNeed: {
        message: t("register.town"),
        value: "" || "Choose...",
      },
      isNotRepeat: {
        message: t("town.changeToEdit"),
        value: group && group.town,
      },
    },
    missionId: {
      isCheckMission: {
        message: t("town.inGame"),
        value: "",
      },
    },
  };

  useEffect(() => {
    validate();
  }, [data]);

  const validate = () => {
    const errors = validator(data, validatorConfig);
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };
  const isValid = Object.keys(errors).length === 0;

  return (
    <>
      <MissionLoader>
        <div className="md:container md:mx-auto w-full my-5 text-lg">
          {group &&
            group.town &&
            !isValid &&
            (!params.id ? (
              <div className="mt-10">
                <Missions list={missions} paymentForm={paymentForm} />
                {modal ? (
                  <PaymentFormModal
                    paymentForm={paymentForm}
                    missionId={missionId}
                  />
                ) : null}
              </div>
            ) : (
              <PlayLoader>
                <Go />
              </PlayLoader>
            ))}
        </div>
      </MissionLoader>
    </>
  );
}

ListGo.propTypes = {};

export default ListGo;
